<template>
    <v-dialog
        v-if="visible"
        v-model="visible"
        transition="dialog-top-transition"
        scrollable
        persistent
        max-width="500"
    >
        <v-card class="modal-maincard">

            <v-toolbar dark flat dense>
                <v-toolbar-title>{{ $t(title) }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="wrapperFormModal">

                <div
                    v-if="!isNotifyRepeatRecieved"
                    class="onlyReadData"
                    v-html="$t('АФК_Уведомление')"
                >

                </div>
                <div
                    v-else
                    class="onlyReadData"
                >
                    Время бездействия пользователя в системе истекло.<br>
                    Необходимо пройти повторную аутентификацию.
                </div>

            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    color="cyan"
                    text
                    depressed
                    @click="localOk"
                >
                    {{ !isNotifyRepeatRecieved ? $t("Да") : $t("Ок") }}
                </v-btn>

            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "NotifyInactiveDlg",
    data () {
        return {
            title: "Внимание",

            options: {
                color: 'grey lighten-3',
                width: 400,
                zIndex: 200,
                noconfirm: false,
            },
        }
    },
    computed: {
        ...mapGetters('dialogs/notifyInactive', { visible: 'isVisible', isNotifyRepeatRecieved: 'isNotifyRepeatRecieved' }),
    },
    methods: {
        ...mapActions('dialogs/notifyInactive', ['ok', 'cancel']),
        localOk() {
            !this.isNotifyRepeatRecieved ? this.ok() : this.cancel();
        }
    }
}
</script>